import { COOKIE_SID } from "@/constants/normal";
import Cookies from "js-cookie";

export const getSid = async () => {
  const sid = Cookies.get(COOKIE_SID) || "";

  return sid;
};
